import { render, staticRenderFns } from "./dsdw.vue?vue&type=template&id=b53ab8b4&scoped=true"
import script from "./dsdw.vue?vue&type=script&lang=js"
export * from "./dsdw.vue?vue&type=script&lang=js"
import style0 from "./dsdw.vue?vue&type=style&index=0&id=b53ab8b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53ab8b4",
  null
  
)

export default component.exports